import React, {useContext, useEffect, useState} from "react";
import { Route, Switch } from "react-router-dom";
import NewObject from "../../../overbox/sheet/paymentterminal/NewObject";
import ObjectSheet from "../../../sheet/ObjectSheet";
import Listing from "../../../table/Listing";
import usePrevious from "../../../../class/tool/usePrevious";
import FilterPopup from "../../../table/FilterPopup";
import Store from "../../../../stories/_account/Stores/Store";
import PaymentTerminalController from "../../../../stories/_setting/PaymentTerminals/PaymentTerminalController";
import LicenseController from "../../../../stories/_account/Licenses/LicenseController";
import ListingContext from "../../../../context/ListingContext";
import BackofficeContext from "../../../../context/BackofficeContext";
import "../../../../css/page/content/paymentterminal/PaymentTerminal.css";

const PaymentTerminal = () => {
    const item = "paymentterminals";
    const itemClass = "paymentterminal";
    const titleWindow = "Terminaux de paiement";
    const placeholderSearch = "un terminal de paiment";
    const titleNbItems = "terminaux de paiement";
    const emptyList = "Aucun terminal de paiement";
    const textRemoveButton = "ce terminal de paiement";
    const activeHistory = false;
    const { setEvent } = useContext(BackofficeContext);
    const [ pageSelect, setPageSelect ] = useState(1);
    const [ loading, setLoading ] = useState(true);
    const [ licenses, setLicenses ] = useState([]);
    const [ list, setList ] = useState([]);
    const [ pagination, setPagination ] = useState(null);
    const [ perPage, setPerPage ] = useState(25);
    const [ sortingName, setSortingName ] = useState("updated_at");
    const [ sortingValue, setSortingValue ] = useState("desc");
    const [ filters, setFilters ] = useState({});
    const [ filterValues, setFilterValues ] = useState({});
    const [ contextValues, setContextValues ] = useState({});
    const [ showFilters, setShowFilters ] = useState(false);
    const prevPageSelect = usePrevious(pageSelect);
    const prevPerPage = usePrevious(perPage);

    const initFilters = () => {
        setFilterValues(prev => ({
            ...prev,
            license_id: null,
            brand: null,
            interfaceType: null,
            inputs: [],
            input: null
        }));
    }
    const getPaymentTerminals = (pPage = 1, pPerPage = 25, pSortingName = "", pSortingValue = "") => {
        let controller = new PaymentTerminalController();
        let paramPage = pPage !== 1 ? pPage : pageSelect;
        let paramPerPage = pPerPage !== 25 ? pPerPage : perPage;
        let paramSortingName = pSortingName !== "" ? pSortingName : sortingName;
        let paramSortingValue = pSortingValue !== "" ? pSortingValue : sortingValue;

        setLoading(true);

        controller._callback = handleGetPaymentTerminals;
        controller.index(filterValues, paramPage, paramPerPage, paramSortingName, paramSortingValue, false);
    }
    const handleGetPaymentTerminals = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setList(list);
                setPagination(pagination !== undefined ? pagination : null );
                break;
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite lors de la récupération des terminaux"
                });
                break;
        }

        setLoading(false);
    }
    const getLicenses = () => {
        const store = new Store(JSON.parse(localStorage.getItem("store")));
        const controller = new LicenseController();
        controller._callback = handleGetLicenses;
        controller.index(store);
    }
    const handleGetLicenses = (list, error, status) => {
        switch (status) {
            case 200:
                let licensesTmp = [
                    {
                        name: "Toutes les licences",
                        id: -1
                    }
                ];

                for (let item in list) {
                    let license = list[item];
                    licensesTmp.push({
                        id: license.id,
                        name: license.name + " (" + license.number + ")"
                    })
                }

                setLicenses(licensesTmp);

                break
            default:
                console.error(list, error, status);
                break;
        }
    }
    const updateFilters = () => {
        setFilters(prev => ({
            ...prev,
            licenses: licenses,
            brands: PaymentTerminalController._paymentTerminalBrands,
            interfaceTypes: PaymentTerminalController._paymentTerminalInterfaceTypes
        }));
    }
    const updatePageSelect = page => {
        setPageSelect(page);
    }
    const handleRefresh = (force = true) => {
        if (force) {
            if (pageSelect !== 1) {
                setPageSelect(1);
                return;
            }
        }

        getPaymentTerminals(pageSelect, perPage, sortingName, sortingValue);
    }
    const handleUpdate = object => {
        let index = list.findIndex(item => item.id === object.id);
        if (index < 0) return;

        let listTmp = list.slice();
        let keys = Object.keys(listTmp[index]);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (object[key] !== undefined)
                listTmp[index][key] = object[key];
        }

        setList(listTmp)
    }
    const handleRemove = () => {
        handleRefresh()
    }
    const openFilters = () => {
        setShowFilters(true);
    }
    const closeFilters = () => {
        setShowFilters(false);
    }
    const validFilters = values => {
        closeFilters();
        setFilterValues(values);
    }

    const model = [
        {
            "class": "name",
            "sortingParam": "name",
            "title": "Nom",
            "attributes": ["name"],
            "type": "text"
        }, {
            "class": "model",
            "sortingParam": "model",
            "title": "Modèle",
            "attributes": ["brandResume"],
            "type": "text"
        }, {
            "class": "protocol",
            "sortingParam": "protocol",
            "title": "Protocole",
            "attributes": ["protocol"],
            "type": "text"
        },
        {
            "class": "interface",
            "sortingParam": "interface",
            "title": "Connexion",
            "attributes": ["connectionResume"],
            "type": "text"
        }/*,
        {
            "class": "licenses",
            "sortingParam": "",
            "title": "Licences",
            "attributes": ["licensesString"],
            "type": "licensesManagement"
        }*/
    ]
    const options = [
        {
            "class": "add",
            "title": "Créer " + placeholderSearch,
            "action": "",
            "link": "/" + item + "/new"
        }
    ]
    const secondaryOptions = []

    useEffect(() => {
        document.title = "Back office - " + titleWindow

        initFilters();
        getLicenses();
    }, []);
    useEffect(() => {
        updateFilters();
    }, [licenses]);
    useEffect(() => {
        if (prevPageSelect === undefined || prevPerPage === undefined) return;

        if (pageSelect !== prevPageSelect || perPage !== prevPerPage)
            handleRefresh(false);
    }, [pageSelect, perPage]);
    useEffect(() => {
        if (Object.keys(filterValues).length === 0) return;

        handleRefresh(true);
    }, [filterValues]);
    useEffect(() => {
        setContextValues(prev => ({
            ...prev,
            page: pageSelect,
            typeFilters: "paymentTerminals",
            filters,
            filterValues,
            showFilters,
            openFilters,
            closeFilters,
            validFilters
        }));
    }, [showFilters, pageSelect, filters, filterValues]);

    return(
        <ListingContext.Provider value={contextValues}>
            <FilterPopup />
            <Listing
                item={ item }
                itemClass={ itemClass }
                placeholderSearch={ placeholderSearch }
                titleNbItems={ titleNbItems }
                emptyList={ emptyList }
                model={ model }
                options={ options }
                secondaryOptions={ secondaryOptions }
                activeHistory={ activeHistory }
                pageSelect={ pageSelect }
                updatePageSelect={ updatePageSelect }
                list={ list }
                loading={ loading }
                pagination={ pagination }
                checkable={ false }
                openable={ true }
                setPerPage={ setPerPage }
                sortingName={ sortingName }
                sortingValue={ sortingValue }
                setSortingName={ setSortingName }
                setSortingValue={ setSortingValue }
            />
            <Switch>
                <Route exact path={ "/" + item + "/new" }>
                    <NewObject handleIndex={ handleRefresh } />
                </Route>
                <Route exact path={ "/" + item + "/:id/(information)" }>
                    <ObjectSheet
                        objectType={ itemClass }
                        previousLink={ item }
                        textRemoveButton={ textRemoveButton }
                        handleUpdate={ handleUpdate }
                        handleRemove={ handleRemove } />
                </Route>
            </Switch>
        </ListingContext.Provider>
    )
}

export default PaymentTerminal;
